import { translate } from '../i18n/translate'

const getFilterTranslation = (key: string, params?: {}, translationDebugEnabled?: boolean): string => {
    let result = translate(key, params)

    if (result === null) {
        const keyParts = key.split('.')
        result = keyParts.length > 3 ? keyParts.slice(3).join('.') : keyParts[keyParts.length - 1]
    }

    return translationDebugEnabled && result !== key ? `${result} [${key}]` : result
}

export default getFilterTranslation
